import React from "react";
import NavBar from "../../components/navBar/NavBar";
import "../../assets/style/style.css";
import axios from "axios";
require("dotenv").config();
const url = process.env.REACT_APP_API_TASK;
//const URL = process.env.urlApi;
class Memorial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      empresa: null,
      tecnico: null,
      endereco: null,
      dataVisita: null,
      idViabilidade: null,
      velocidade_link: null,
      latLongitude: null,
      dificuldade: null,
      logradouro: null,
      numero: null,
      bairro: null,
      cidade: null,
      metragemCabo: null,
      obs: null,
      memorialAprovado: null,
      tecnicoPop: null,
      obsNoc: null,
      aprovadoNoc: null,
      enviarTecnico: null,
      observacaoNoc: null,
      pop1op: null,
      pop2op: null,
      pop3op: null,
      pop1direct: null,
      pop2direct: null,
      pop3direct: null,
      pop1km: null,
      pop2km: null,
      pop3km: null,
      aprovadoGerente: null
    };
  }

  componentDidMount() {
    this.getMemorial();
  }

  getMemorial = () => {
    const id = this.props.match.params.idMemorial;

    const objForm = {
      token: localStorage.getItem("token"),
      id: id
    };

    axios
      .post(
        url + "/memorial",
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        this.setState({
          empresa: response.data.resultMemorial["0"].empresa,
          tecnico: response.data.resultMemorial["0"].tecnico_instalacao_op1,
          endereco: response.data.resultMemorial["0"].endereco,
          dataVisita: response.data.resultMemorial["0"].data_da_visita,
          idViabilidade: response.data.resultViabilidade["0"].id,
          velocidade: response.data.resultViabilidade["0"].velocidade,
          tipo: response.data.resultViabilidade["0"].tipo,
          latLongitude: response.data.resultMemorial["0"].lat_long,
          dificuldade: response.data.resultMemorial["0"].dificuldade_instalacao,
          logradouro: response.data.resultMemorial["0"].logradouro,
          cidade: response.data.resultMemorial["0"].cidade,
          bairro: response.data.resultMemorial["0"].bairro,
          numero: response.data.resultMemorial["0"].numero,
          metragemCabo: response.data.resultMemorial["0"].metragem_de_cabo,
          obs: response.data.resultMemorial["0"].obs,
          aprovadoNoc: response.data.resultMemorial["0"].aprovado,
          enviarTecnico: response.data.resultMemorial["0"].enviar_tecnico,
          observacaoNoc: response.data.resultMemorial["0"].observacao,
          pop1op: response.data.resultMemorial["0"].pop1op,
          pop2op: response.data.resultMemorial["0"].pop2op,
          pop3op: response.data.resultMemorial["0"].pop3op,
          pop1direct: response.data.resultMemorial["0"].pop1direct,
          pop2direct: response.data.resultMemorial["0"].pop2direct,
          pop3direct: response.data.resultMemorial["0"].pop3direct,
          pop1km: response.data.resultMemorial["0"].pop1km,
          pop2km: response.data.resultMemorial["0"].pop2km,
          pop3km: response.data.resultMemorial["0"].pop3km,
          aprovadoGerente:
            response.data.resultMemorial["0"].aprovado_gerente_operacional
        });
      });

    axios
      .post(
        url + "/equipamentos",
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        this.setState({
          equipamentos: response.data
        });
      });

    axios
      .post(
        url + "/fotos",
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        this.setState({
          fotos: response.data
        });
      });
  };

  allEquipamentos = () => {
    let obj = this.state.equipamentos;
    if (obj) {
      return obj.map((imagem, index) => {
        return (
          <React.Fragment key={index}>
            <p className="card-text">
              {" "}
              <b>Item:</b>
              {imagem.equipamento} - <b>Quant:</b> {imagem.quantidade}{" "}
            </p>
          </React.Fragment>
        );
      });
    }
  };

  allFotos = () => {
    let obj = this.state.fotos;
    let linkImg = "http://noc.all.com.br/memorial/upload/";

    if (obj) {
      return obj.map((imagem, index) => {
        let src = linkImg + "/" + imagem.url;
        return (
          <React.Fragment key={index}>
            <img src={src} className="img-fluid" alt="img" />
            <p className="card-text"> {imagem.descricao_texto} </p>
          </React.Fragment>
        );
      });
    }
  };

  allEstrutura = () => {
    if (this.state.pop1op) {
      return (
        <React.Fragment>
          <h5 className="card-title">Estrutura do POP 1</h5>
          <p className="card-text">Nome: {this.state.pop1op}</p>
          <p className="card-text">Direcionado ? {this.state.pop1direct}</p>
          <p className="card-text">
            Distância Cliente x POP: {this.state.pop1km}
          </p>
        </React.Fragment>
      );
    }

    if (this.state.pop2op) {
      return (
        <React.Fragment>
          <h5 className="card-title">Estrutura do POP 2</h5>
          <p className="card-text">Nome: {this.state.pop2op}</p>
          <p className="card-text">Direcionado ? {this.state.pop2direct}</p>
          <p className="card-text">
            Distância Cliente x POP: {this.state.pop2km}
          </p>
        </React.Fragment>
      );
    }

    if (this.state.pop3op) {
      return (
        <React.Fragment>
          <h5 className="card-title">Estrutura do POP 3</h5>
          <p className="card-text">Nome: {this.state.pop3op}</p>
          <p className="card-text">Direcionado ? {this.state.pop3direct}</p>
          <p className="card-text">
            Distância Cliente x POP: {this.state.pop3km}
          </p>
        </React.Fragment>
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/task-descriptions/${this.props.match.params.id}`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            <div className="card marginTop6">
              <h5 className="card-header">Memorial</h5>
              <div className="card-body">
                <h5 className="card-title">Clientes</h5>
                <p className="card-text"> {this.state.empresa} </p>
                <h5 className="card-title">Técnico Responsável</h5>
                <p className="card-text">{this.state.tecnico}</p>
                <h5 className="card-title">Endereço</h5>
                <p className="card-text">{this.state.endereco}</p>
                <h5 className="card-title">Data da Visita</h5>
                <p className="card-text">{this.state.dataVisita}</p>
                <h5 className="card-title">ID Viabilidade</h5>
                <p className="card-text">{this.state.idViabilidade}</p>
                <h5 className="card-title">Velocidade</h5>
                <p className="card-text">
                  {this.state.velocidade} Mbps (Confirmar no contrato)
                </p>
                <h5 className="card-title">Tipo</h5>
                <p className="card-text">{this.state.tipo}</p>
                <h5 className="card-title">Latitude e Longitude</h5>
                <p className="card-text">{this.state.latLongitude}</p>
                <h5 className="card-title">Dificuldade</h5>
                <p className="card-text">{this.state.dificuldade}</p>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">1.Objetivo</h5>
              <div className="card-body">
                <p className="card-text">
                  {" "}
                  Este projeto de infraestrutura consiste no fornecimento de
                  informações e especificações para a montagem de equipamentos
                  no cliente e otimizar o trabalho do técnico.
                </p>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">2.Memorial Descritivo</h5>
              <div className="card-body">
                <h5 className="card-title">Descrição</h5>
                <p className="card-text">
                  O projeto consiste na instalação de um sistema de rádio
                  digital, para o fornecimento de conexão com a rede internet -
                  na velocidade de {this.state.velocidade} Mbps localizado na
                  {this.state.logradouro} {this.state.endereco},{" "}
                  {this.state.numero} - {this.state.bairro}, {this.state.cidade}
                  .
                </p>
                <h5 className="card-title">Dificuldade</h5>
                <p className="card-text">{this.state.dificuldade}</p>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">3.Equipamentos</h5>
              <div className="card-body">
                <h5 className="card-title">Metragem de cado de Rede</h5>
                <p className="card-text">{this.state.metragemCabo}</p>
                <h5 className="card-title">Observações</h5>
                <p className="card-text">{this.state.obs}</p>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">4.Estrutura</h5>
              <div className="card-body">
                {this.allEstrutura()}
                <h5 className="card-title">Fotos</h5>
                {this.allFotos()}
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Área do Noc</h5>
              <div className="card-body">
                <h5 className="card-title">Memorial Aprovado</h5>
                <p className="card-text">{this.state.aprovadoNoc}</p>
                <h5 className="card-title">Enviar Técnico ao POP</h5>
                <p className="card-text">{this.state.enviarTecnico}</p>
                <h5 className="card-title">Observações</h5>
                <p className="card-text">{this.state.observacaoNoc}</p>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Aprovação do Gerente Operacional </h5>
              <div className="card-body">
                <h5 className="card-title">Memorial Aprovado</h5>
                <p className="card-text">{this.state.aprovadoGerente}</p>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Solicitações de Material</h5>
              <div className="card-body">
                <h5 className="card-title">Data</h5>
                <p className="card-text">{this.state.dataVisita}</p>
                <h5 className="card-title">Cliente</h5>
                <p className="card-text"> {this.state.empresa} </p>

                <h5 className="card-title">Item Solicitado</h5>
                {this.allEquipamentos()}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Memorial;
